import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import UpdateMovieListStatusService from '../../../Services/Mutations/UpdateMovieListStatusService'
import { ToastStyle } from '../../Data/MovieStaticData'
import { Modal } from 'react-bootstrap'

function ActionsDiv(props) {
  const {
    item,
    handleDeleteClick,
    status,
    serviceData,
    setServiceData,
    index,
    ApproveOptionBoolean,
    DeleteOptionPermission,
    EDitOptionPermission,
  } = props
  const [showPopup, setshowPopup] = useState(false)
  const [itemDel, setItemDel] = useState({})
  const [itemIndex, setItemIndex] = useState('')
  const editItem = item.SK.replace('#', '$')
  const ApproveList = async movieListID => {
    const tempServiceData = [...serviceData]
    console.log('approve')
    const response = await UpdateMovieListStatusService({ movieListID, status: 'published' })
    console.log(response)
    if (response.statusCode === 'M022') {
      toast.success(response.statusMessage, ToastStyle)
      tempServiceData.splice(index, 1)
      setServiceData(tempServiceData)
    }
  }

  const ApproveDelete = () => {
    handleDeleteClick(itemDel, itemIndex)
    setItemDel({})
    setItemIndex('')
    setshowPopup(false)
  }

  return (
    <>
      <div className='d-flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
        {status === 'draft' && ApproveOptionBoolean && (
          <button
            className='rounded m-1'
            type='button'
            name={item.PK}
            id={item.SK}
            onClick={() => ApproveList(item.SK)}
          >
            <i className='fas fa-upload'></i>
          </button>
        )}
        {EDitOptionPermission && <Link data-toggle='tooltip' title={'EditList'} to={`/editlist?${editItem}`} target='_blank'>
          <button className='rounded m-3' type='button'>
            <i className='fas fa-pencil-alt fa-lg' />
          </button>
        </Link>}
        {DeleteOptionPermission && <button
          className='rounded m-1'
          type='button'
          name={item.PK}
          id={item.SK}
          onClick={() => {
            setItemDel(item)
            setItemIndex(index)
            setshowPopup(true)
          }}
        >
          <i className='fas fa-trash fa-lg'></i>
        </button>}
      </div>
      <Modal
        show={showPopup}
        dialogClassName='modal-90w'
        // fullscreen={'md-down'}
        onHide={() => {
          setItemDel({})
          setItemDel('')
          setshowPopup(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete it</Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              setItemDel({})
              setItemDel('')
              setshowPopup(false)
            }}
          >
            Cancel
          </button>
          <button type='button' className='btn btn-primary' onClick={() => ApproveDelete()}>
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ActionsDiv
